<template>
    <!-- <p style="letter-spacing: 5px;">0505557002494</p> -->

    <div class="container">
        <v-row>
            <v-col col="8">
                <div style="display:grid;margin-left:150px;margin-top:100px;justify-items:end;letter-spacing: 5px;font-size:12px;">
                    <div style="display:flex">
                        <div>0</div>
                        <div>5</div>
                        <div>0</div>
                        <div>5</div>
                        <div>5</div>
                        <div>5</div>
                        <div>7</div>
                        <div>0</div>
                        <div>0</div>
                        <div>2</div>
                        <div>4</div>
                        <div>9</div>
                        <div>4</div>
                    </div>
                </div>
                <div style="display:grid;margin-left:150px;justify-items:end;letter-spacing: 4px;font-size:12px;">
                    <div style="display:flex">
                        <div>0</div>
                        <div>0</div>
                        <div>0</div>
                        <div>0</div>
                        <div>6</div>
                    </div>
                </div>
            </v-col>
            <v-col col="4"></v-col>
        </v-row>

        <!-- <p style="margin-left:232px;font-size:12px;letter-spacing: 7px;">00006</p> -->
    </div>
</template>
  
<script>
import { formatPrice } from "@/js/handler";
import img_arin from "@/assets/arin_assets/arin.png";
import { HTTP_ARIN } from "@/axios_arin";
export default {
    inject: {
        theme: {
            default: {
                isDark: false,
            },
        },
    },
    name: "Pos_bill_after",
    data() {
        return {
            loading_page: false,
            dialog_cancel_order: false,
            search: '',
            img_arin: img_arin,
            footer_Props: {
                'items-per-page-text': 'รายการต่อหน้า'
            },
            data_list: [],
            seller: {},

        }
    },
    methods: {
        link(link) {
            window.location.href = link;
        },
        formatPrice(number) {
            return formatPrice(number)
        },
        formatMonth(value) {
            switch (value) {
                case '01':
                    return 'มกราคม'
                case '02':
                    return 'กุมภาพันธ์'
                case '03':
                    return 'มีนาคม'
                case '04':
                    return 'เมษายน'
                case '05':
                    return 'พฤษภาคม'
                case '06':
                    return 'มิถุนายน'
                case '07':
                    return 'กรกฏาคม'
                case '08':
                    return 'สิงหาคม'
                case '09':
                    return 'กันยายน'
                case '10':
                    return 'ตุลาคม'
                case '11':
                    return 'พฤศจิกายน'
                case '12':
                    return 'ธันวาคม'
            }
        },
        async getSotre() {
            let config = {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": `Bearer ${this.$store.state.store_arin.access_token}`
                }
            }
            let store_id = this.$store.state.store_arin.user_data.store_id;
            await HTTP_ARIN.get('/stores/detail/' + store_id, config).then((res) => {
                if (res.data.successful === true) {
                    this.seller = res.data.storeDetail;
                }
            })
        },
        async getDetail() {
            let config = {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": `Bearer ${this.$store.state.store_arin.access_token}`
                }
            }
            let id = this.$route.params.id;
            await HTTP_ARIN.get('/invoice/create/taxinvoice/' + id, config).then((res) => {
                if (res.data.successful === true) {
                    this.data_list = res.data.data;
                }
            })
        },
    },
    mounted() {
        this.getSotre()
        this.getDetail()
    }
}
</script>
  
<style scoped>
.btn_add_data {
    font-size: 16px;
    color: #FFF;
    background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
    border-radius: 10px;
    /* width: 100%; */
}

.v-btn:not(.v-btn--round).v-size--default {
    height: 36px;
    min-width: 45px;
    padding: 0 10px;
}

.border-tax {
    border: 1px solid #B7B7B7;
}

.border-style-b {
    /* border-style: dotted;
    border-color: #ADADAD; */
    border-top: 0;
    border-left: 0;
    border-right: 0;
    border-bottom: 1px dotted #ADADAD;
}

.title_page_right {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
}

.title_page_center {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.font-14 {
    font-size: 14px !important;
}

.font-12 {
    font-size: 12px !important;
}

.h-40 {
    height: 35px !important;
}

.bb-0 {
    border-bottom: 0px !important;
}
</style>
  